/**
 * Shared icon map for catalog datasources
 * Used by DatasourceLink and ChangeDatasourceIconDialog
 *
 * @property {string} key - Unique identifier for the icon
 * @property {string} label - Display label for the icon
 * @property {string} url - URL path to the icon image
 * @property {boolean} [padded] - If true, the icon should be displayed with padding (for simple icons)
 */
export const catalogIconMap = [
  { key: 'table', label: 'Table (Default)', url: '/img/catalog_database_pb.svg', padded: true },
  { key: 'api', label: 'API', url: '/img/catalog_api_pb.svg', padded: true },
  { key: 'compliance', label: 'Orion Compliance', url: '/img/orionCompliance.png', padded: true },
  { key: 'planning', label: 'Orion Planning', url: '/img/orionPlanning.png', padded: true },
  { key: 'accounting', label: 'Orion Portfolio Accounting', url: '/img/orionPortfolioAccounting.png', padded: true },
  { key: 'orion', label: 'Orion', url: '/img/orion.svg', padded: true },
  { key: 'risk', label: 'Orion Risk Intelligence', url: '/img/ori.svg', padded: true },
  { key: 'redtail', label: 'Redtail', url: '/img/redtail.svg', padded: true },
  { key: 'wealthbox', label: 'Wealthbox', url: '/img/wb.svg', padded: true },
  { key: 'databricks', label: 'Databricks', url: '/img/databricks.svg', padded: true },
  { key: 'summit', label: 'Summit', url: '/img/summit.svg', padded: true },
  { key: 'snowflake', label: 'Snowflake', url: '/img/snowflake.svg', padded: true },
  { key: 'salesforce', label: 'Salesforce', url: '/img/salesforce.svg', padded: true },
  { key: 'airtable', label: 'Airtable', url: '/img/airtable.svg', padded: true },
  { key: 'quickbooks', label: 'QuickBooks', url: '/img/quickbooks.svg', padded: true }
]

/**
 * Get the icon entry for a datasource
 * @param {Object} datasource - The datasource object
 * @returns {Object} The icon entry from catalogIconMap
 */
export const getIcon = (datasource) => {
  const iconKey = (datasource.icon || datasource.type || '').toLowerCase()
  const icon = catalogIconMap.find(x => x.key?.toLowerCase() === iconKey)

  return icon || catalogIconMap[0] // Default to table icon
}

/**
 * Get the icon URL for a datasource
 * @param {Object} datasource - The datasource object
 * @returns {string} The URL of the icon
 */
export const getIconUrl = (datasource) => {
  return getIcon(datasource).url
}

/**
 * Check if the icon should be displayed with padding
 * @param {Object} datasource - The datasource object
 * @returns {boolean} True if the icon should be padded
 */
export const isIconPadded = (datasource) => {
  return getIcon(datasource).padded === true
}

/**
 * Get icon options formatted for SydSelect
 * @returns {Array} Array of { label, value } objects
 */
export const getIconSelectOptions = () => {
  return catalogIconMap.map(icon => ({
    label: icon.label,
    value: icon.key
  }))
}
